import React, { ReactNode } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import {
  AriksaIcon,
  IAriksaIconProps,
  CustomTooltip,
} from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { getIconColor } from 'components/Icons/Components/getIconColor';

interface Props extends IAriksaIconProps {
  upper: ReactNode;
  lower: ReactNode;
  cloudProvider?: string;
  isLoading?: boolean;
  titleWidth?: string | number;
}

export const StackedHeader = (props: Props) => {
  const {
    upper,
    lower,
    type,
    cloudProvider,
    icon,
    isLoading,
    color,
    bg,
    titleWidth = '90%',
    style,
    border = false,
    ...rest
  } = props;
  const iconColor =
    color ??
    (type || cloudProvider
      ? getIconColor((type ?? cloudProvider) as string)
      : undefined) ??
    customTheme.colors.primary;
  const resolvedIconColor =
    iconColor === 'primary' ? customTheme.colors.primary : iconColor;
  const iconBackgroundColor = bg ?? colorOpacity(resolvedIconColor, 0.2);

  return (
    <HStack spacing={4} w={'full'}>
      {(type || icon) && (
        <AriksaIcon
          type={type}
          //size="medium"
          bg={iconBackgroundColor}
          color={resolvedIconColor}
          icon={icon}
          border={border}
          style={{ ...style, borderRadius: 12, p: 2, w: 12, h: 12 }}
          useCustomColor
          {...rest}
        />
      )}
      {isLoading ? (
        <Box>
          <CustomSpinner />
        </Box>
      ) : (
        <Stack spacing={0} flex={1} w={titleWidth}>
          <Box
            w={titleWidth}
            whiteSpace={'nowrap'}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            fontWeight={400}
            fontSize="xl"
            fontFamily="Rubik"
          >
            <CustomTooltip label={upper} aria-label="A tooltip">
              {upper}
            </CustomTooltip>
          </Box>
          <Box
            color={customTheme.colors.gray['250']}
            fontWeight={400}
            fontSize="16px"
            fontFamily="Rubik"
          >
            {lower}
          </Box>
        </Stack>
      )}
    </HStack>
  );
};
